import { toVnInput } from '../contract';

export interface ReminderLabelInput {
  kind: 'OFFSET' | 'CUSTOM' | 'NOW';
  offsetMinutes?: number | null;
  sendTimeLocal?: string | null;
  sendAt?: string | null;
}

/** Nhãn mốc nhắc trong bảng: "Trước 7 ngày · 09:00", "Ngày diễn ra · 08:00", ngày giờ VN, "Gửi ngay". */
export function reminderLabel(r: ReminderLabelInput): string {
  if (r.kind === 'NOW') return 'Gửi ngay';
  if (r.kind === 'CUSTOM') return toVnInput(r.sendAt) || '—';
  const minutes = r.offsetMinutes ?? 0;
  let head: string;
  if (minutes <= 0) head = 'Ngày diễn ra';
  else if (minutes % 1440 === 0) head = `Trước ${minutes / 1440} ngày`;
  else if (minutes % 60 === 0) head = `Trước ${minutes / 60} giờ`;
  else head = `Trước ${minutes} phút`;
  return r.sendTimeLocal ? `${head} · ${r.sendTimeLocal}` : head;
}
